var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTorquueStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9525 29.3701L32.0159 30.2766L58.3085 20.7778L58.1337 20.3162L31.8534 29.8146L53.9132 12.6684L53.6175 12.2722L31.5458 29.431L47.2375 6.29324L46.8229 6.02383L31.1431 29.1489L38.9176 2.30807L38.4456 2.16352L30.6714 29.0167L29.7649 1.08013L29.2734 1.09608L30.18 29.0326L20.6812 2.74L20.2195 2.91486L29.718 29.1952L12.5718 7.13534L12.1755 7.43105L29.3344 29.5028L6.19662 13.811L5.92722 14.2256L29.0523 29.9055L2.21146 22.1309L2.0669 22.6029L28.9201 30.3771L0.983515 31.2837L0.999462 31.7751L28.936 30.8685L2.64339 40.3673L2.81824 40.829L29.0986 31.3306L7.03873 48.4768L7.33444 48.873L29.4062 31.7141L13.7144 54.8519L14.129 55.1213L29.8089 31.9962L22.0343 58.8371L22.5063 58.9816L30.2805 32.1285L31.1871 60.065L31.6785 60.0491L30.7719 32.1125L40.2707 58.4052L40.7324 58.2303L31.234 31.95L48.3801 54.0098L48.7764 53.7141L31.6175 31.6424L54.7553 47.3341L55.0247 46.9195L31.8996 31.2397L58.7405 39.0142L58.885 38.5422L32.0319 30.7681L59.9684 29.8615L59.9525 29.3701Z",
    fill: "#F6BEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorquueStar);
export default __webpack_public_path__ + "static/media/torquue-star.e5fd92b2c4d0d0db340454b24468a9c0.svg";
export { ForwardRef as ReactComponent };